export default "__VITE_ASSET__BlWv_ST5__"